export const ctaLink = "https://zbooking.in/KxVMm";

export const heroData = {
  headline: "Stop Overpaying Taxes as an NRI or Founder.",
  subheadline: "Losing lakhs to missed DTAA benefits, wrong TDS, and the wrong business structure? One cross-border strategy fixes all of it.",
  ctaText: "Book Your Compliance Diagnostic Call",
  ctaSubtext: "15 minutes. Leave with a clear action plan — even if we never work together.",
  backgroundImage: "https://images.pexels.com/photos/29470839/pexels-photo-29470839.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
};

export const problemData = {
  title: "Pick your situation. I've seen all of them.",
  founderProblems: {
    heading: "Founder going global?",
    summary: "Setting up in Dubai but getting conflicting advice and worried about costly mistakes?",
    items: [
      { text: "Every \"consultant\" gives a different answer and a different price for Dubai setup", keyword: "different answer" },
      { text: "Nobody tells you what happens to your India company, investments, or tax status after you move", keyword: "India company" },
      { text: "Scared of burning \u20b920-30 Lakh on the wrong structure", keyword: "\u20b920-30 Lakh" },
      { text: "One wrong decision costs you years", keyword: "costs you years" }
    ]
  },
  nriProblems: {
    heading: "NRI anywhere in the world?",
    summary: "Dealing with property sales, tax notices, or compliance gaps with advisors who don't get it?",
    items: [
      { text: "Sold property in India \u2014 TDS is wrong, capital gains unclear, repatriation impossible", keyword: "TDS is wrong" },
      { text: "Tax notice from India \u2014 your local advisor has zero clue about Indian law", keyword: "zero clue" },
      { text: "Investing in India but don't know if you're compliant as an NRI", keyword: "compliant" },
      { text: "DTAA benefits exist \u2014 nobody's helping you claim them", keyword: "DTAA benefits" },
      { text: "Leaving money on the table \u2014 you just don't know how much", keyword: "money on the table" }
    ]
  },
  rootCause: "Your Indian Tax Consultant doesn't understand international tax. Your advisor abroad doesn't understand Indian law. You're paying two people who don't talk to each other. That ends here."
};

export const aboutData = {
  name: "CA Rahul Taneja",
  handle: "@ca_rahul_dxb",
  title: "\"I've been on both sides of this.\"",
  paragraphs: [
    "Started in corporate India \u2014 fund accounting, investment analysis, and financial reporting. Did my CA. Understood the Indian system inside out.",
    "Then I moved to Dubai and saw what nobody was solving.",
    "NRIs across US, UK, Canada, Singapore, Australia were filing taxes with CAs who had never heard of DTAA or FEMA. Nobody sat at the intersection.",
    "So I built Finpire Global \u2014 right here in Dubai \u2014 to be that one firm."
  ],
  specificResult: "Last year alone, we helped NRIs recover \u20b92.3 crore in wrongly deducted TDS.",
  image: "https://customer-assets.emergentagent.com/job_cross-border-wealth/artifacts/pmgzag2g_rahul%20pic.png",
  social: {
    instagram: "https://www.instagram.com/ca_rahul_dxb",
    youtube: "https://www.youtube.com/@Rahul_kumar_dxb"
  }
};

export const videoData = {
  title: "See how it works",
  subtitle: "Watch a quick explainer on how we help NRIs and founders sort their cross-border finances.",
  videoUrl: ""
};

export const credibilityData = {
  stats: [
    { value: "10+", label: "Years Experience", sublabel: "Chartered Accountant (ICAI)" },
    { value: "1,000+", label: "Clients Served", sublabel: "Across 40+ countries" },
    { value: "3", label: "Companies Founded", sublabel: "Finpire Global, Investments LLP, Capital Research" },
    { value: "22,000+", label: "Followers", sublabel: "@ca_rahul_dxb" },
    { value: "5M+", label: "Views", sublabel: "35+ viral reels on NRI finance" },
    { value: "40+", label: "Countries", sublabel: "Active YouTube & Instagram Educator" }
  ]
};

export const offerData = {
  title: "One partner. India + the world.",
  services: [
    {
      icon: "Building2",
      tag: "SETUP",
      title: "Dubai Company Setup & Structuring",
      tagline: "Set up your Dubai business the right way \u2014 with India tax implications planned from day one.",
      includes: [
        "Free zone vs. mainland analysis for your business type",
        "Trade license and company registration",
        "Visa processing (investor / partner / employee)",
        "Bank account opening assistance",
        "India-side tax structuring and compliance planning"
      ],
      price: "Starting at $4,000 / AED 15,000",
      ctas: [
        { label: "Book Your Compliance Diagnostic Call", href: "https://zbooking.in/KxVMm", primary: true },
      ]
    },
    {
      icon: "ArrowLeftRight",
      tag: "TRANSITION",
      title: "India-to-Dubai Transition Planning",
      tagline: "Pre-move residential status strategy, India business restructuring, and full tax impact analysis BEFORE you move.",
      includes: [
        "Pre-move residential status strategy",
        "India business restructuring — what to keep, close, or convert",
        "Bank/demat NRI re-classification",
        "FEMA & RBI compliance for moving money",
        "Full tax impact analysis BEFORE you move"
      ],
      price: "$280 / AED 999",
      ctas: [
        { label: "Book Your Compliance Diagnostic Call", href: "https://zbooking.in/KxVMm", primary: true },
      ]
    },
    {
      icon: "Globe",
      tag: "TAX ADVISORY",
      title: "Global NRI Tax Advisory & Filing",
      tagline: "DTAA optimization, ITR filing, capital gains, FBAR/FATCA — coordinated with your overseas CPA.",
      includes: [
        "Residential status planning",
        "DTAA optimization — India has treaties with 90+ countries",
        "ITR filing for NRIs",
        "Capital gains on property, ESOPs, investments",
        "Coordination with your overseas CPA/accountant"
      ],
      price: "$160 / AED 599",
      ctas: [
        { label: "Start My NRI Tax Filing", href: "/nri-tax-filing", primary: true }
      ]
    },
    {
      icon: "Shield",
      tag: "COMPLIANCE",
      title: "Compliance & Tax Notice Management",
      tagline: "TDS certificates, notice response, FEMA compliance — handled from anywhere in the world.",
      includes: [
        "TDS on property sale — Section 195/197 certificate",
        "Income tax notice response and scrutiny handling",
        "FEMA/RBI compliance",
        "GST for NRI-owned India entities",
        "Lower TDS certificates — stop overpaying"
      ],
      price: "$140 / AED 499",
      ctas: [
        { label: "Book & Pay Now", href: "https://nas.io/carahultaneja/sessions/paid-strategy-session", primary: true }
      ]
    },
    {
      icon: "Plane",
      tag: "RETURN PLANNING",
      title: "Moving Back to India — Return Planning",
      tagline: "Your tax status, foreign assets, and Indian investments all need restructuring BEFORE you land.",
      includes: [
        "Residential status transition planning",
        "FEMA compliance for bringing money back",
        "Foreign asset and income disclosure",
        "Re-classification of bank accounts & investments",
        "Tax-efficient unwinding of overseas structures"
      ],
      price: "$700 / AED 2,499",
      ctas: [
        { label: "Book & Pay Now", href: "https://nas.io/carahultaneja/sessions/moving-back-to-india-complete-tax--compliance-roadmap-for-nris", primary: true }
      ]
    },
    {
      icon: "TrendingUp",
      tag: "INVESTMENTS",
      title: "NRI Investment Advisory",
      tagline: "Tax-efficient cross-border investing, real estate structuring, and repatriation planning.",
      includes: [
        "Portfolio review for tax-efficient cross-border investing",
        "Mutual fund, PMS, AIF guidance for NRIs",
        "India real estate structuring — purchase, rental income, sale",
        "Repatriation planning — move money legally",
        "DTAA-aligned to minimize tax on investment income"
      ],
      price: "$140 / AED 499",
      ctas: [
        { label: "Book & Pay Now", href: "https://nas.io/carahultaneja/sessions/nri-investment-planning--structuring", primary: true }
      ]
    },
    {
      icon: "Compass",
      tag: "STRATEGY",
      title: "Founder Advisory",
      tagline: "Strategic financial planning for founders scaling from India to Dubai or across borders.",
      includes: [
        "Strategic financial planning across borders",
        "Monthly MIS and reporting",
        "Cash flow structuring & investor-readiness",
        "VAT compliance",
        "Zoho-powered automated systems"
      ],
      price: "Book Diagnostic Call",
      ctas: [
        { label: "Book Your Compliance Diagnostic Call", href: "https://zbooking.in/KxVMm", primary: true }
      ]
    },
    {
      icon: "Brain",
      tag: "DEEP-DIVE",
      title: "Paid Strategy Session",
      tagline: "For HNIs and complex cases who want a deep-dive strategy session \u2014 not just a quick chat.",
      includes: [
        "60-minute one-on-one with CA Rahul",
        "Complete cross-border tax situation analysis",
        "Personalised action plan with specific next steps",
        "Recording of the session for your reference",
        "One follow-up email with written summary"
      ],
      price: "$150 / AED 499 (one-time)",
      ctas: [
        { label: "Book & Pay Now", href: "https://nas.io/carahultaneja/sessions/paid-strategy-session", primary: true }
      ]
    }
  ]
};

export const dreamOutcomeData = {
  title: "What \"sorted\" actually looks like:",
  outcomes: [
    { text: "Dubai company structured RIGHT \u2014 not whatever a sales agent pushed", keyword: "structured RIGHT", icon: "Building2" },
    { text: "Taxes optimized using DTAA \u2014 legally saving lakhs every year", keyword: "saving lakhs", icon: "BadgeDollarSign" },
    { text: "Every property, investment, and bank account fully compliant", keyword: "fully compliant", icon: "ShieldCheck" },
    { text: "ONE team across India and your country \u2014 no juggling 3-4 advisors", keyword: "ONE team", icon: "Users" },
    { text: "Tax notice? Handled. Property sale? Clean.", keyword: "Handled", icon: "FileCheck" },
    { text: "Moving back? Your money lands before you do \u2014 fully planned", keyword: "fully planned", icon: "Plane" },
    { text: "Tax season doesn't give you anxiety \u2014 done before deadlines", keyword: "before deadlines", icon: "CalendarCheck" },
    { text: "Cross-border financial life \u2014 completely sorted", keyword: "completely sorted", icon: "Globe" }
  ]
};

export const forNotForData = {
  forYou: {
    title: "This is for you if:",
    items: [
      { text: "Indian founder expanding or relocating to Dubai", keyword: "expanding or relocating" },
      { text: "NRI anywhere with financial ties to India", keyword: "financial ties" },
      { text: "Planning to move back to India \u2014 want to do it right", keyword: "do it right" },
      { text: "Want ONE advisor who understands both sides", keyword: "ONE advisor" },
      { text: "Want proactive strategy, not reactive return-filing", keyword: "proactive strategy" }
    ]
  },
  notForYou: {
    title: "Not for you if:",
    items: [
      { text: "You want the cheapest CA to \"just file the return\"", keyword: "cheapest CA" },
      { text: "Looking for compliance shortcuts", keyword: "shortcuts" },
      { text: "Not serious about protecting your wealth", keyword: "not serious" }
    ]
  }
};

export const socialProofData = {
  testimonials: [
    { quote: "My US CPA had no clue about Indian capital gains. Rahul handled the India side, coordinated with my CPA, saved me \u20b914 Lakh.", location: "San Francisco, USA", name: "Vikram S." },
    { quote: "Kept delaying my London to Dubai move for 2 years. Rahul gave me a complete transition blueprint. Moved in 3 months.", location: "London, UK", name: "Priya M." },
    { quote: "3 advisors in 3 countries giving 3 different answers. Finpire brought it all together \u2014 one plan.", location: "Multiple Countries", name: "Anand R." },
    { quote: "Moving back after 8 years in Singapore. Had no idea about foreign asset disclosure. Finpire saved me from a \u20b910 Lakh penalty.", location: "Singapore", name: "Deepa K." }
  ]
};

export const leadMagnetData = {
  sectionTitle: "Not ready to talk yet? Start here.",
  options: [
    {
      title: "NRI Tax Compliance Checklist",
      subtitle: "Download the free NRI Tax Compliance Checklist and find out if you have gaps you don't even know about.",
      bullets: [
        "9 compliance areas every NRI must check annually",
        "Common DTAA mistakes that cost lakhs",
        "Residential status decision tree — are you really an NRI?",
        "Deadlines you can't afford to miss in 2026",
        "When to file in India vs. your country of residence"
      ],
      ctaText: "Download Free Checklist",
      ctaLink: "https://nas.io/carahultaneja/digital-files/mistakes-nris-should-avoid",
      microcopy: "No spam. No sales calls. Just one useful PDF and a welcome email."
    },
    {
      title: "Dubai Business Setup Guide",
      subtitle: "7 costly mistakes Indian founders make when setting up a Dubai company — and how to avoid every single one.",
      bullets: [
        "Free zone vs. mainland — which is right for you?",
        "Hidden costs most agents don't tell you about",
        "Visa types and what each one really costs",
        "Banking options and requirements explained",
        "India tax implications of your Dubai structure"
      ],
      ctaText: "Download Free Guide",
      ctaLink: "https://nas.io/carahultaneja/digital-files/dubai-business-setup-guide",
      microcopy: "Before you set up in Dubai, read this."
    },
    {
      title: "Join NRI, HNI & Founder Community",
      subtitle: "Connect with 1,000+ NRIs, HNIs, and founders navigating cross-border finance — together.",
      bullets: [
        "Weekly live Q&A sessions with CA Rahul",
        "Exclusive tax updates and regulatory changes",
        "Network with NRIs, HNIs & founders globally",
        "Early access to new guides and resources",
        "Private discussion forum for members only"
      ],
      ctaText: "Join the Community",
      ctaLink: "https://nas.io/carahultaneja",
      microcopy: "Free to join. Exclusive insights, live sessions, and peer support."
    }
  ]
};

export const finalCtaData = {
  headline: "Your Wealth Crosses Borders. Your Advisor Should Too.",
  subheadline: "Whether you are an NRI, a founder, or an investor — the first step is the same. Let's talk.",
  description: "Book your Compliance Diagnostic Call — from wherever you are. We'll map your situation, find the gaps, and give you a clear action plan.",
  ctaText: "Book My Compliance Diagnostic Call",
  subtext: "1,000+ Indians across 40+ countries stopped overpaying. Your turn.",
  paidSession: {
    title: "Compliance Diagnostic Call",
    duration: "30 minutes. Strategy Call.",
    description: "A focused 30-minute compliance strategy call covering your cross-border tax situation, key risk areas, and a personalised action plan to protect your wealth.",
    ctaText: "Book Your Compliance Diagnostic Call",
    link: "https://zbooking.in/KxVMm"
  }
};

export const footerData = {
  name: "CA Rahul Taneja",
  credentials: "Chartered Accountant (ICAI) | 10+ Years Experience",
  company: "Finpire Global Accounting & Auditing Co LLC, Dubai",
  serving: "Serving NRIs & Founders in US, UK, Canada, Australia, Singapore, UAE, Europe & beyond",
  email: "info@taxpire.com",
  social: {
    handle: "@ca_rahul_dxb",
    instagram: "https://www.instagram.com/ca_rahul_dxb",
    youtube: "https://www.youtube.com/@Rahul_kumar_dxb",
    linkedin: "https://www.linkedin.com/in/rahulkumardxb/",
    tiktok: "https://www.tiktok.com/@brewbiz.withrahul"
  }
};

export const navData = {
  brand: "Rahul Taneja",
  brandSub: "Chartered Accountant",
  logo: "https://customer-assets.emergentagent.com/job_cross-border-wealth/artifacts/pmgzag2g_rahul%20pic.png",
  links: [
    { label: "Services", href: "#services" },
    { label: "About", href: "#about" },
    { label: "Results", href: "#results" },
    { label: "Testimonials", href: "#testimonials" }
  ],
  ctaText: "Book a Call"
};
